import { render, staticRenderFns } from "./CollegeShuang.vue?vue&type=template&id=6d6e3f2a&scoped=true"
import script from "./CollegeShuang.vue?vue&type=script&lang=js"
export * from "./CollegeShuang.vue?vue&type=script&lang=js"
import style0 from "./CollegeShuang.vue?vue&type=style&index=0&id=6d6e3f2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e3f2a",
  null
  
)

export default component.exports